module.exports = __webpack_public_path__ + "img/actions-empty-image.0f3387d3.png";